import { NgModule } from '@angular/core';

import { WelcomeComponent } from './welcome.component';
import { NWMControls } from 'app/components/Controls/NWMControls.module';
import { SharedModule } from "app/modules/shared/shared.module";

@NgModule({
    imports: [
        NWMControls,
        SharedModule.forRoot(),
        WelcomeComponent,
    ],
    providers: []
})
export class WelcomeModule { }
